import { createContext, useState, useContext } from 'react'

const INITIAL_STATE = {
    drawer: false,
    store: {
        distributor_from_id: null
    },
    cart: {
        open: false
    }
}

export const DataContext = createContext()

export function DataProvider({ children }){
    const [ data, setData ] = useState(INITIAL_STATE)

    const cache = () => {
        try{
            let dataCache = localStorage.getItem('@data')
                dataCache = dataCache ? JSON.parse(dataCache) : {}

            setData(dataCache)
            return dataCache
        }catch(err){
            console.warn('Não foi possível obter dados do storage.', err)
        }
    }
    
    const save = (data) => {
        try{
            localStorage.setItem('@data', JSON.stringify(data))
        }catch(err){
            console.warn('Não foi possível armazenar dados no storage.', err)
        }
    }

    const toggleDrawer = () => {
        const _data = Object.assign({}, data)
        _data.drawer = !data.drawer
        setData(_data)
    }

    const closeDrawer = () => {
        const _data = Object.assign({}, data)
        _data.drawer = false
        setData(_data)
    }

    const setOrder = order => {
        const _data = Object.assign({}, data)
        _data.order = order
        setData(_data)
    }

    const setStore = store => {
        const _data = Object.assign({}, data)
        _data.store = store
        setData(_data)
    }

    const setCart = cart => {
        const _data = Object.assign({}, data)
        _data.cart = {..._data.cart, ...cart}
        setData(_data)
    }

    return <DataContext.Provider value={{ 
        data,
        setData,
        cache,
        save,

        drawer: data.drawer, toggleDrawer, closeDrawer,
        order: data.order, setOrder,
        store: data.store, setStore,
        cart: data.cart, setCart
    }}>{children}</DataContext.Provider>
}

export function useData(){
    const context = useContext(DataContext)
    return context
}